import { Alert } from 'react-bootstrap'
import { useAuthState } from 'web_core/firebase/hooks'
import { Designed } from 'web_core/types'

type Props = {
  prefix?: string
  suffix?: string
}

export const LoginRecommender = ({
  prefix,
  suffix,
  ...otherProps
}: Designed<Props>) => {
  const { isSignedIn, showSignInPopup } = useAuthState()
  return isSignedIn === false ? (
    <Alert variant="info" {...otherProps}>
      {prefix}
      <span
        className="cursor-pointer text-primary"
        onClick={() => {
          showSignInPopup()
        }}
      >
        ログイン
      </span>
      {suffix}
    </Alert>
  ) : (
    <></>
  )
}
